export const newUrl = 'http://192.168.1.124:18080'//测试

// export const newUrl = 'http://odw.ayy123.com/odw'//上线





// WEBPACK FOOTER //
// ./src/assets/js/newurl.js